import * as React from "react";
import EventHandler = React.EventHandler;
import MouseEventHandler = React.MouseEventHandler;
import MouseEvent = React.MouseEvent;
import { AddWbsComponentEvents, NODE_KINDS } from "../WbsEvents";
export const TITLE_PLACEHOLDER: string = "Click to edit name";

export interface PropsAddWbsComponentMenu extends AddWbsComponentEvents {
  className: string;
  nodeId: string;
  x: number;
  y: number;
}

export const AddWbsComponentMenu: React.SFC<PropsAddWbsComponentMenu> = props => {

  return (
    <g>
      <text
        className={props.className}
        x={props.x}
        y={props.y}
        onClick={event => props.onAddChild(props.nodeId, TITLE_PLACEHOLDER, NODE_KINDS.wbsComponent)}
      >
        C
      </text>

      <text
        className={props.className}
        x={props.x + 20}
        y={props.y}
        onClick={event => props.onInsertParent(props.nodeId, TITLE_PLACEHOLDER, NODE_KINDS.wbsComponent)}
      >
        P
      </text>

      <text
        className={props.className}
        x={props.x + 40}
        y={props.y}
        onClick={event => props.onAddSiblingBefore(props.nodeId, TITLE_PLACEHOLDER, NODE_KINDS.wbsComponent)}
      >
        SB
      </text>

      <text
        className={props.className}
        x={props.x + 70}
        y={props.y}
        onClick={event => props.onAddSiblingAfter(props.nodeId, TITLE_PLACEHOLDER, NODE_KINDS.wbsComponent)}
      >
        SA
      </text>
    </g>
  );
};


// WEBPACK FOOTER //
// ./src/components/AddWbsComponentMenu.tsx